// apps/web/src/utils/photoUtils.ts
import { environment } from '../config/environment';

/**
 * Получение полного URL для фото посетителя
 */
export const getPhotoUrl = (photoUrl?: string): string | null => {
  if (!photoUrl || photoUrl.trim() === '') {
    return null;
  }

  // Если это data URL (base64)
  if (photoUrl.startsWith('data:')) {
    return photoUrl;
  }

  // Если это полный URL
  if (photoUrl.startsWith('http://') || photoUrl.startsWith('https://')) {
    return photoUrl;
  }

  // Если это относительный путь, начинающийся с /
  if (photoUrl.startsWith('/')) {
    return `${environment.apiBaseUrl}${photoUrl}`;
  }

  // По умолчанию считаем, что это имя файла в uploads/visitors/
  return `${environment.apiBaseUrl}/uploads/visitors/${photoUrl}`;
};

/**
 * Получение URL для отображения в img src
 */
export const getImageSrc = (photoUrl?: string): string => {
  const fullUrl = getPhotoUrl(photoUrl);
  return fullUrl || '';
};
